import { useMutation } from '@tanstack/react-query'
import { Toast } from 'ui/components'

import { handlerServerError } from '@orbit/errors'

import * as Service from '../../service'

export const useDelete = () =>
  useMutation({
    mutationFn: (ids: number[]) => Promise.all(ids.map((id) => Service.Batch.remove({ id }))),
    onError: (error) => handlerServerError(error),
    onSuccess: async () => {
      Toast.successSmall('Batch(es) was(were) successfully deleted.')
    }
  })
